import { ApiService } from '../../services/api.service';
import { AuthenticationService } from "../../services/authentication.service";
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TemplateService } from "../../services/template.service";
import { TranslateService } from '@ngx-translate/core';
var ZipFileComponent = (function () {
    function ZipFileComponent(apiService, modalService, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.msgs = [];
        this.allBranch = true;
        this.allDocType = true;
        this.allDocumentType = [];
        this.allBranchSelected = [];
        this.selectedValues = [];
        this.currentPage = 1;
        this.loading = false;
        this.loading_all_zip = false;
        this.cancel_loading_all_zip = false;
        this.loading_all_zip_message = '';
        this.no_data = true;
        this.value = 0;
        this.sum_docs_count = 0;
        this.loading_all_zip_progress = 0;
        this.errorMsg = '';
        this.monthList = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
        this.monthListDropdown = [];
        this.yearList = [];
        this.allZipCurrent = 0;
        this.index = 0;
        this.tableArray = [];
        this.branchList = null;
        this.allBranchList = null;
        this.docTypeList = null;
        this.loading_excel_report = false;
        this.is_TH = false;
        this.tableCol = [];
    }
    ZipFileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadTexts();
        this.populateDropdown();
        this.searchData();
        this.translate.onLangChange.subscribe(function (event) {
            if (event.lang === 'th') {
                _this.is_TH = true;
            }
            if (event.lang === 'en') {
                _this.is_TH = false;
            }
            _this.loadTexts();
            _this.populateDropdown();
        });
    };
    ZipFileComponent.prototype.loadTexts = function () {
        var _this = this;
        this.monthListDropdown = [];
        this.tableCol = [];
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            var documentData = _this.template.getDropdown();
            documentData[0] = { label: _this.translate.instant('COMMON.ALL'), value: null };
            _this.rdDocumentType = documentData;
            _this.loadInput();
            _this.monthListDropdown.push({ label: _this.translate.instant('MONTH.JANUARY'), value: 1 }, { label: _this.translate.instant('MONTH.FEBRUARY'), value: 2 }, { label: _this.translate.instant('MONTH.MARCH'), value: 3 }, { label: _this.translate.instant('MONTH.APRIL'), value: 4 }, { label: _this.translate.instant('MONTH.MAY'), value: 5 }, { label: _this.translate.instant('MONTH.JUNE'), value: 6 }, { label: _this.translate.instant('MONTH.JULY'), value: 7 }, { label: _this.translate.instant('MONTH.AUGUST'), value: 8 }, { label: _this.translate.instant('MONTH.SEPTEMBER'), value: 9 }, { label: _this.translate.instant('MONTH.OCTOBER'), value: 10 }, { label: _this.translate.instant('MONTH.NOVEMBER'), value: 11 }, { label: _this.translate.instant('MONTH.DECEMBER'), value: 12 });
            _this.tableCol.push(
            // { field: 'group', header: 'ประเภทธุรกิจ' },
            { field: 'company_name', header: _this.translate.instant('FILTER.COMPANY') }, { field: 'branch', header: _this.translate.instant('TABLE.BRANCH-NAME') }, { field: 'rd_doc_type', header: _this.translate.instant('FILTER.DOCUMENT-TYPE') }, 
            // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
            { field: 'total_doc', header: _this.translate.instant('TABLE.NUMBER-DOCUMENTS') });
        });
    };
    ZipFileComponent.prototype.populateDropdown = function () {
        var currentDate = new Date();
        // populate year list back within 10 years
        var thisYear = currentDate.getFullYear();
        for (var i = 0; i <= 10; i++) {
            this.yearList.push({ label: (thisYear - i).toString(), value: thisYear - i });
        }
        // set current month and year
        this.selectedMonth = currentDate.getMonth() + 1;
        this.selectedYear = thisYear;
    };
    ZipFileComponent.prototype.canUserDownloadDoc = function () {
        return this.authService.isAdmin() || this.authService.isAccountantAdminTH() || this.authService.isAccountantAdminINC() || this.authService.isUIH();
    };
    ZipFileComponent.prototype.loadInput = function () {
        var _this = this;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.homeproGroup = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        // this.canDownloadZipOption = [{
        //   label: 'ทั้งหมด',
        //   value: null
        // },{
        //   label: 'เฉพาะที่ตรวจสอบจากบัญชีแล้ว',
        //   value: true
        // },{
        //   label: 'เฉพาะที่ยังไม่ได้ตรวจสอบ',
        //   value: false
        // }];
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    ZipFileComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate == _this.selectedCompany)
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
        });
    };
    ZipFileComponent.prototype.getProgress = function () {
        var progress = this.total_rows_count > 0 ? ((this.uploaded_row_count / this.total_rows_count) * 100.0) : 0;
        return Math.floor(progress);
    };
    ZipFileComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.searchData(params);
    };
    ZipFileComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    ZipFileComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    ZipFileComponent.prototype.searchBranch = function (event) {
        var _this = this;
        if (this.branchList == null) {
            this.apiService.getBranch().subscribe(function (data) {
                _this.branchList = data;
                _this.branchSuggest = _this.filterData(event.query, 'full_name', _this.branchList);
            });
        }
        else {
            this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
    };
    ZipFileComponent.prototype.searchDocumentType = function (event) {
        var _this = this;
        if (this.docTypeList == null) {
            this.apiService.getDocumentType().subscribe(function (result) {
                _this.docTypeList = result;
                _this.typeSuggest = _this.filterData(event.query, 'type', _this.docTypeList);
            });
        }
        else {
            this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
    };
    ZipFileComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    ZipFileComponent.prototype.selectAllBranch = function () {
        this.branch = null;
    };
    ZipFileComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    ZipFileComponent.prototype.canUserApproveDoc = function () {
        return this.authService.isAccountantTH() || this.authService.isAccountantINC();
    };
    ZipFileComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        this.allBranchSelected = [];
        this.allDocumentType = [];
        _.forEach(this.branch, function (data) {
            // this.allBranchSelected = [];
            _this.allBranchSelected.push(_.toNumber(data.id));
        });
        _.forEach(this.documentType, function (data) {
            // this.allDocumentType = [];
            _this.allDocumentType.push(_.toNumber(data.id));
        });
        var data = {
            not_uploaded_only: this.notUploaded,
            month: this.selectedMonth,
            year: this.selectedYear,
            group_id: this.selectedHomeproGroup,
            company_id: this.selectedCompany,
            can_download_zip: this.selectedCanDownloadZip,
            document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
            //branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
            branch_id: this.selectedBranch ? [this.selectedBranch] : null,
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        this.apiService.postSaleZipTax(data, params).subscribe(function (result) {
            _this.loading = false;
            _this.tableData = result.results;
            _this.uploaded_row_count = result.uploaded_row_count;
            _this.total_rows_count = result.total_rows_count;
            _this.sum_docs_count = result.sum_docs_count;
            _this.no_data = _.isEmpty(_this.tableData);
            _this.totalItems = result.count;
            _this.selectedValues = [];
            for (var i = 0; i < _this.tableData.length; i++)
                _this.selectedValues.push(false);
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    ZipFileComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        if (!this.no_data) {
            this.table.reset();
        }
        this.searchData();
    };
    ZipFileComponent.prototype.confirmDocument = function (event, content, index, data) {
        event.currentTarget.blur();
        event.preventDefault();
        this.modalData = data;
        this.modal = this.modalService.open(content);
    };
    ZipFileComponent.prototype.confirm = function () {
        var _this = this;
        if (this.modalData.uploaded === false) {
            var params = {
                approved: true,
                month: this.selectedMonth,
                year: this.selectedYear,
                group: this.modalData.group,
                rd_document_type: this.modalData.rd_document_type,
                document_type: this.modalData.document_type,
                corporate_branch: this.modalData.corporate_branch,
            };
            this.apiService.approveUploadSale(params).subscribe(function (result) {
                _this.modal.close();
            });
        }
        else {
            var params = {
                approved: false,
                month: this.selectedMonth,
                year: this.selectedYear,
                group: this.modalData.group,
                rd_document_type: this.modalData.rd_document_type,
                document_type: this.modalData.document_type,
                corporate_branch: this.modalData.corporate_branch,
            };
            this.apiService.approveUploadSale(params).subscribe(function (result) {
                _this.modal.close();
            });
        }
    };
    ZipFileComponent.prototype.revertBack = function () {
        this.searchData();
        this.modal.close();
    };
    ZipFileComponent.prototype.clearData = function () {
        this.startDate = new Date();
        this.endDate = new Date();
        this.selectedCompany = null;
        this.selectedCanDownloadZip = null;
        this.selectedHomeproGroup = null;
        this.selectedRdDocumentType = null;
        ;
        this.branch = null;
        this.documentType = null;
        this.allDocType = true;
        this.allBranch = true;
        this.notUploaded = false;
        this.selectedBranch = null;
        this.searchButtonClicked();
    };
    ZipFileComponent.prototype.getExportDocs = function (data) {
        var _this = this;
        var params = {
            month: this.selectedMonth,
            year: this.selectedYear,
            document_type_id: data.document_type,
            rd_document_type: data.rd_document_type,
            branch_id: data.corporate_branch,
            group_id: data.group
        };
        data.loading_zip = true;
        this.apiService.getAllZipFile(params).subscribe(function (obj) {
            var filename = _this.getZipFileName(data);
            _this.apiService.createDownloadFile(obj, filename);
            if (!data.uploaded)
                _this.uploaded_row_count++;
            data.uploaded = true;
            data.loading_zip = false;
        }, function (error) {
            data.loading_zip = false;
        });
    };
    ZipFileComponent.prototype.clearBranch = function () {
        this.allBranchSelected = [];
    };
    ZipFileComponent.prototype.clearDocType = function () {
        this.allDocumentType = [];
    };
    ZipFileComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
            return;
        }
    };
    ZipFileComponent.prototype.selectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = true;
        }
    };
    ZipFileComponent.prototype.deselectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = false;
        }
    };
    ZipFileComponent.prototype.canSelectAll = function () {
        return this.tableData.filter(function (data) { return data.can_download_zip === true; }).length > 0;
    };
    ZipFileComponent.prototype.selectDeselectAll = function (checked) {
        if (checked) {
            this.selectAll();
            return;
        }
        this.deselectAll();
    };
    ZipFileComponent.prototype.DownloadSelected = function (content) {
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i])
                continue;
            this.tableArray.push(this.tableData[i]);
        }
        if (!_.isEmpty(this.tableArray)) {
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
            this.allZipCount = this.tableArray.length;
            this.cancel_loading_all_zip = false;
            this.download(this.index, this.tableArray);
        }
    };
    ZipFileComponent.prototype.EnabledDownloadSelected = function () {
        return this.selectedValues.filter(function (select) { return select == true; }).length > 0;
    };
    ZipFileComponent.prototype.DownloadExcelReport = function () {
        var _this = this;
        this.loading_excel_report = true;
        var params = {
            month: this.selectedMonth,
            year: this.selectedYear,
        };
        this.apiService.getExcelReport(params).subscribe(function (obj) {
            var filename = 'tax_report_' + _this.selectedMonth + '_' + _this.selectedYear + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            _this.loading_excel_report = false;
        }, function (error) {
            _this.loading_excel_report = false;
        });
    };
    ZipFileComponent.prototype.download = function (index, tableArray) {
        var _this = this;
        this.loading_all_zip = true;
        if (index >= tableArray.length) {
            this.loading_all_zip = false;
            this.loading_all_zip_message = 'Download ' + this.translate.instant('COMMON.COMPLETE') + ' (' + this.translate.instant('FILTER.ALL') + ' ' + tableArray.length + ' ' + this.translate.instant('SEARCH.ITEMS') + ')';
            for (var i = 0; i < tableArray.length; i++) {
                if (!tableArray[i].uploaded)
                    this.uploaded_row_count++;
                tableArray[i].uploaded = true;
            }
            return;
        }
        if (this.cancel_loading_all_zip) {
            return;
        }
        var params = {
            month: this.selectedMonth,
            year: this.selectedYear,
            document_type_id: tableArray[index].document_type,
            rd_document_type: tableArray[index].rd_document_type,
            branch_id: tableArray[index].corporate_branch,
            group_id: tableArray[index].group,
        };
        this.apiService.getAllZipFile(params).subscribe(function (obj) {
            if (_this.cancel_loading_all_zip) {
                return;
            }
            // this.loading_all_zip = false;
            var filename = _this.getZipFileName(tableArray[index]);
            _this.apiService.createDownloadFile(obj, filename);
            _this.allZipCurrent++;
            _this.loading_all_zip_progress = (_this.allZipCurrent / _this.allZipCount) * 100;
            // data.xmlLoading = false;
            setTimeout(function () {
                _this.download(index + 1, tableArray);
            }, 1000);
        }, function (error) {
            _this.loading_all_zip = false;
            _this.loading_all_zip_message = _this.translate.instant('ERROR.TRY-AGAIN');
            // data.xmlLoading = false;
        });
    };
    ZipFileComponent.prototype.getZipFileName = function (data) {
        var file_name = '' + this.selectedMonth + '_' + this.selectedYear + '_' + data.branch__code + '_' + data.corporate_branch__corporate__name + '_' + data.rd_document_type;
        file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
        return file_name + '.zip';
    };
    ZipFileComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.cancel_loading_all_zip = true;
        this.loading_all_zip = false;
        this.allZipCurrent = 0;
        this.loading_all_zip_progress = 0;
    };
    ZipFileComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
        // this.searchData();
    };
    ZipFileComponent.prototype.testt = function (tt) {
        console.log(tt);
    };
    return ZipFileComponent;
}());
export { ZipFileComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file.component.ts.pre-build-optimizer.js